<template>
  <div class="legend">
    <div class="levels">
      <div class="columns">
        <div class="column">
          <div class="level-title">
            <div class="square is-level-source" />
            <h3 class="title is-6">
              Level -1
            </h3>
          </div>
          <p>Song at the origin of an adaptation in which {{ artist.name }} is involved</p>
        </div>
        <div class="column">
          <div class="level-title">
            <div class="square is-level-own" />
            <h3 class="title is-6">
              Level 0
            </h3>
          </div>
          <p>Song in which {{ artist.name }} is involved</p>
        </div>
        <div class="column">
          <div class="level-title">
            <div class="square is-level-target" />
            <h3 class="title is-6">
              Level +1
            </h3>
          </div>
          <p>Adaptation from a song in which {{ artist.name }} is involved</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		artist: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.legend {
    display: flex;
    margin-bottom: 30px;

    .levels {
      max-width: 800px;
      margin-right: 10px;
    }
    .level-title {
        display: flex;
        align-items: center;
        margin-bottom: 0.3rem;
    }
    .square {
        height: 10px;
        width: 10px;
        border-radius: 15px;
        background-color: #999999;
        border: 1px solid #4b4b4b;
        margin-right: 0.5rem;

        &.is-level-source {
            background-color: #3aa1db;
            border-color: #1f5a7a;
        }

        &.is-level-target {
            background-color: #fca82b;
            border-color: #865a16;
        }
    }
    p {
        font-size: 0.8rem;
    }

    .scale {
      display: flex;
      max-width: 300px;
      .title {
        margin-bottom: 4px;
      }
    }

    .circles {
      position: relative;
      height: 30px;
      width: 30px;
      margin-right: 20px;
      .circle {
        border-radius: 50px;
        border: 1px solid #666;
        position: absolute;
        bottom: 0;

        &.is-1 {
          height: 10px;
          width: 10px;
          left: 10px;
        }

        &.is-2 {
          height: 20px;
          width: 20px;
          left: 5px;
        }

        &.is-3 {
          height: 30px;
          width: 30px;
        }
      }
    }
}
</style>
